import React from 'react'
import { TrendingUp, TrendingDown, Minus } from 'lucide-react'

interface TrendPillProps {
  value: number
  suffix?: string
  className?: string
}

export function TrendPill({ value, suffix = '%', className = '' }: TrendPillProps) {
  const positive = value > 0
  const neutral = value === 0
  const formatted = `${positive ? '+' : ''}${value.toFixed(2)}${suffix}`

  const color = neutral
    ? 'text-text-dim'
    : positive
    ? 'text-success'
    : 'text-error'

  const Icon = neutral ? Minus : positive ? TrendingUp : TrendingDown

  return (
    <span className={`inline-flex items-center gap-1 text-tiny tabular-nums ${color} ${className}`}>
      <Icon size={12} />
      {formatted}
    </span>
  )
}
